import { connect } from 'react-redux'

import { applyFilter } from '../../redux/modules/search/actions'

import Bedrooms from '../../components/filters/Bedrooms'

const mapStateToProps = (state) => ({
  minBedrooms: state.search.filters.minBedrooms || 0,
  maxBedrooms: state.search.filters.maxBedrooms || 10,
})

const actionCreators = { applyFilter }

export default connect(mapStateToProps, actionCreators)(Bedrooms)



// WEBPACK FOOTER //
// ./src/containers/filters/Bedrooms.js